export const statusLabels = {
  new: 'New',
  contacted: 'Contacted',
  quoted: 'Quoted',
  won: 'Won',
  lost: 'Lost',
}

export const statusIcons = {
  new: 'mdi-email-outline',
  contacted: 'mdi-phone-outline',
  quoted: 'mdi-file-document-edit-outline',
  won: 'mdi-check-circle-outline',
  lost: 'mdi-close-circle-outline',
}

export const sourceLabels = {
  'website-form': 'Website',
  manual: 'Manual',
  referral: 'Referral',
  phone: 'Phone',
  google: 'Google',
  other: 'Other',
}
